import { Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'm-skeleton',
  templateUrl: './m-skeleton.component.html',
  styleUrls: ['./m-skeleton.component.scss']
})
export class MSkeletonComponent extends Skeleton {}
